import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { App } from './app';
import { AppRoutingModule } from './app-routing-module';
import { Modal } from './components/modal/modal';
import { toastHttpInterceptor } from './shared/toast/toast-http.interceptor';
import { ToastComponent } from './shared/toast/toast.component';
import { provideToastConfig } from './shared/toast/toast.service';
import { WebSocketService } from './shared/websocket.service';

@NgModule({
  declarations: [App],
  imports: [BrowserModule, AppRoutingModule, ToastComponent, Modal],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([toastHttpInterceptor])),
    provideToastConfig({
      maxVisible: 5,
      defaultDuration: 5000,
      position: 'top-right',
      pauseOnHover: true,
      newestOnTop: true,
    }),
    provideClientHydration(withEventReplay()),
    WebSocketService,
  ],
  bootstrap: [App],
})
export class AppModule {}
